export default "__VITE_PUBLIC_ASSET__94331cb5__"